import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, lastValueFrom, Observable } from 'rxjs';
import { ApiUrlService } from './api-url.service';
import { ErrorControlResponse, LogResponse, PollingResponse } from '../models/interfaz';

@Injectable({
  providedIn: 'root'
})
export class DebugService {
  private errorStatusSubject = new BehaviorSubject<ErrorControlResponse | undefined>(undefined);
  private logDataSubject = new BehaviorSubject<LogResponse | undefined>(undefined);

  constructor(private apiUrl: ApiUrlService, private http: HttpClient) {}

  get errorEstatus(): BehaviorSubject<ErrorControlResponse | undefined> {
    return this.errorStatusSubject;
  }

  set errorEstatus(value: ErrorControlResponse) {
    this.errorStatusSubject.next(value);
  }

  get logData(): BehaviorSubject<LogResponse | undefined> {
    return this.logDataSubject;
  }

  set logData(value: LogResponse) {
    this.logDataSubject.next(value);
  }

  async getErrorStatus(): Promise<Observable<ErrorControlResponse | undefined>> {
    if (this.errorStatusSubject.value !== undefined) {
      return this.errorStatusSubject.asObservable();
    }
    const url = `${this.apiUrl.statusApi}`;
    const datos = await lastValueFrom(this.http.get<ErrorControlResponse>(url));
    this.errorStatusSubject.next(datos);
    return this.errorStatusSubject.asObservable();
  }

  getPolling(): Observable<PollingResponse> {
    const url = `${this.apiUrl.pollingApi}`;
    return this.http.get<PollingResponse>(url);
  }

  async getLogData(
    farmacia_nom: string,
    tipo: 'instalador' | 'launcher' | 'acumulado' | 'motor' | 'asistente' | 'error' = 'motor',
    filePath?: string,
    limit: number = 5
  ): Promise<LogResponse> {
    const params = new URLSearchParams({ farmacia_nom, tipo, limit: String(limit) });
    if (filePath) {
      params.set('file_path', filePath);
    }
    const url = this.apiUrl.logsApi.includes('?')
      ? `${this.apiUrl.logsApi}&${params.toString()}`
      : `${this.apiUrl.logsApi}?${params.toString()}`;
    const datos = await lastValueFrom(this.http.get<LogResponse>(url));
    this.logDataSubject.next(datos);
    return datos;
  }
}
